import { useAuth } from "@/context/auth";
import LoginWithPhoneNumber from "@/modules/auth/phoneNumber";
import LoginWithPassWord from "@/modules/auth/userPass";
import useUpdateImei from "@/services/fcm/hooks/useUpdateImei";
import { Loader, Stack } from "@mantine/core";
import { useEffect, useState } from "react";
import ReactGa from "react-ga4";
import { useSearchParams } from "react-router-dom";

function Login() {
  const type = "userPass";

  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState<boolean>(true);
  const { mutate } = useUpdateImei();
  const { token } = useAuth();

  useEffect(() => {
    ReactGa.send(window.location.pathname);
  }, []);

  useEffect(() => {
    // const fcm = searchParams.get("fcm");
    const platform = searchParams.get("platform");
    const imei = searchParams.get("imie");
    if (platform === "android") {
      // localStorage.setItem("fcm", fcm);
      localStorage.setItem("platform", platform);
      localStorage.setItem("imie", imei || "");
      mutate(imei || "");
    }
    if (token) {
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [searchParams]);

  // const gotoSignUp = () => {
  //   ReactGa.event({
  //     action: "signUp",
  //     category: "auth",
  //     label: "goToSignUpPage",
  //   });
  //   navigate("/auth/signUp");
  // };

  if (loading)
    return (
      <Stack h="100svh" flex={1} justify="center" align="center">
        <Loader />
      </Stack>
    );

  return (
    <Stack justify="center">
      {type === "userPass" ? <LoginWithPhoneNumber /> : <LoginWithPassWord />}
      {/* <Group justify="center">
        <Text mt="lg" size="xs">
          هنوز ثبت نام نکرده ایید؟
          <Anchor pr="5" underline="always" onClick={gotoSignUp}>
            ثبت نام کنید
          </Anchor>
        </Text>
      </Group> */}
    </Stack>
  );
}

export default Login;
